import { Box, Button, FormControl, FormControlLabel, FormLabel, InputLabel, MenuItem, Radio, RadioGroup, Select, Switch, Typography } from "@mui/material"
import { getTaskPreferences, updateTaskPreferences } from "api/services/preferencess";
import BottomBar from "components/BottomBar";
import Loader from "components/Loader";
import { snack } from "components/toast";
import { UserProfileContext } from "context/UserProfile";
import { useContext, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { handleError } from "utils/handleError";

const TaskPreferences = () => {
    const queryClient = useQueryClient();
    const { data: uData } = useContext(UserProfileContext);
    const [task, setTask] = useState<any>({ taskDate: 15, colletData: "organization", checkListComplete: false, milestoneComplete: false, deliverableComplete: false,CheckMilChekUR : false, financialprefill: false, multudins: false });
    const [initialTask, setInitialTask] = useState<any>(null);
    const { isLoading: queryLoading } = useQuery(
        ["task-preferenecs", uData?.id],
        getTaskPreferences,
        {
            onSuccess: (res: any) => {
                const taskData = {
                    checkListComplete: false,
                    milestoneComplete: false,
                    deliverableComplete: false,
                    CheckMilChekUR : false,
                    financialprefill: false,
                    multudins: false,
                    ...res?.data?.taskPreferences
                };

                setTask(taskData);
                setInitialTask(taskData);
            }
        }
    )

    const { data, mutate, isLoading } = useMutation(updateTaskPreferences, {
        onSuccess: () => {
            snack.success("Task Preferences Updated!");
            queryClient.invalidateQueries("task-preferenecs");
        },
        onError: (err: any) => {
            snack.error(handleError(err));
        },
    });

    const handleUpdateTaskPrefernces = () => {
        return new Promise((resolve, reject) => {
            const data = { ...task };

            mutate(
                { data: { taskPreferences: data } },
                {
                    onSuccess: () => {
                        setInitialTask(data);
                        resolve(true);
                    },
                    onError: (err) => {
                        reject(err);
                    }
                }
            );
        });
    }

    if (queryLoading) return <Loader />

    return <Box m={2}>
        <Typography variant="h6" mt={3}>
            Task Collect Data Preferences
        </Typography>
        <Typography variant="body1" >Who's Contact Details to be visible in I-Pro Client Link ?</Typography>
        <FormControl>
            <RadioGroup
                value={task?.colletData || "organization"}
                onChange={(value) => {
                    setTask({ ...task, colletData: value.target.value })
                }}
                row
            >
                <FormControlLabel value="organization" control={<Radio />} label="Organization" />
                <FormControlLabel value="user" control={<Radio />} label="User" />
            </RadioGroup>
        </FormControl>

        <Typography variant="h6" mt={3}>
            Task Creation
        </Typography>

        <Box display="flex" alignItems="center">
            <Typography mr={3}>
                Do you want to disable automatic prefilling of the Financial Year field?
            </Typography>

            <Switch
                checked={task?.financialprefill || false}
                onChange={(e) =>
                    setTask({
                        ...task,
                        financialprefill: e.target.checked
                    })
                }
            />
        </Box>
        <Box display="flex" alignItems="center">
            <Typography mr={3}>
                Allow duplicate UDINs across tasks?
            </Typography>

            <Switch
                checked={task?.multudins || false}
                onChange={(e) =>
                    setTask({
                        ...task,
                        multudins: e.target.checked
                    })
                }
            />
        </Box>

        <Typography variant="h6" mt={3}>
            Task Edit / Update
        </Typography>

        <Box display="flex" alignItems="center" >
            <Typography mr={3}>
                Should changing the status of milestone(s) / checklist(s) be restricted when the Task Status is Under Review?
            </Typography>

            <Switch
                checked={task?.CheckMilChekUR || false}
                onChange={(e) =>
                    setTask({
                        ...task,
                        CheckMilChekUR: e.target.checked
                    })
                }
            />
        </Box>

        <Typography variant="h6" mt={3}>
            Task Completion
        </Typography>

        <Box display="flex" alignItems="center">
            <Typography mr={3}>
                Should a task be marked as <b>Completed</b> only after every single item on its <b>Checklist</b> is marked as done ?
            </Typography>

            <Switch
                checked={task?.checkListComplete || false}
                onChange={(e) =>
                    setTask({
                        ...task,
                        checkListComplete: e.target.checked
                    })
                }
            />
        </Box>

        <Box display="flex" alignItems="center">
            <Typography mr={3}>
                Should a task be marked as <b>Completed</b> only after every single item on its <b>Milestones</b> is marked as done ?
            </Typography>

            <Switch
                checked={task?.milestoneComplete || false}
                onChange={(e) =>
                    setTask({
                        ...task,
                        milestoneComplete: e.target.checked
                    })
                }
            />
        </Box>

        <Box display="flex" alignItems="center" >
            <Typography mr={3}>
                Should a task be marked as <b>Completed</b> only after every single item on its <b>Deliverables</b> is marked as done ?
            </Typography>

            <Switch
                checked={task?.deliverableComplete || false}
                onChange={(e) =>
                    setTask({
                        ...task,
                        deliverableComplete: e.target.checked
                    })
                }
            />
        </Box>
        {/* <Typography variant="body1" mt={5}>Should employees in the organisation be able to add log hours even after a task is completed ?</Typography>
        <Box mt={2}>
            <Box display="flex" mt={3} alignItems="center">
                <Switch
                    onChange={() => setTask({ ...task, loghours: !task?.loghours })}
                    checked={task?.loghours}
                    sx={{ marginRight: "25px" }}
                />
                <Typography>{task?.loghours ? "On" : "Off"}</Typography>
            </Box>
            {task?.loghours && <>
                <Typography sx={{ mt: 2 }}>How many days should employees be allowed to add log hours after completing a task ?</Typography>
                <FormControl fullWidth sx={{ mt: 2 }}>
                    <InputLabel>Log Hour Preferences</InputLabel>
                    <Select
                        size="small"
                        placeholder="loghourpreferences"
                        labelId="Log Hour Prefenences"
                        id="loghourprefernces"
                        value={task?.logHoursDate || null}
                        onChange={(value) => {
                            setTask({ ...task, logHoursDate: value.target.value })
                        }}
                        label="Log Hour Preferences"
                    >
                        <MenuItem key={"one"} value={1}>
                            One Day
                        </MenuItem>
                        <MenuItem key={"week"} value={7}>
                            One Week
                        </MenuItem>
                        <MenuItem key={"15"} value={15}>
                            15 Days
                        </MenuItem>
                    </Select>
                </FormControl></>}
        </Box> */}
        <Typography variant="h6" mt={3}>
            Whether Task Completion should sync with GST Returns on the Portal,
        </Typography>
        <Box display={"flex"} alignItems={"center"}>
            <Typography variant="body1" mr={3}>For GSTR-1/IFF, GSTR-3B, GSTR-9, GSTR-9C, CMP-08 & GSTR-4 ?</Typography>
            <Switch
                checked={task?.gstrTrack === 'true'}
                onChange={(e) =>
                    setTask({
                        ...task,
                        gstrTrack: e.target.checked ? 'true' : 'false'
                    })
                }
            />
        </Box>
        <Typography variant="h6" mt={1}>
            Completed Task Preferences
        </Typography>
        <Box display={"flex"} alignItems={"center"}>
            <Typography variant="body1">Upto How many Days Completed Tasks to be shown in Task Board and Dashboard?</Typography>
            <FormControl fullWidth sx={{ mt: 1, ml: 4, width: "150px" }}>
                <InputLabel>Preferences</InputLabel>
                <Select
                    size="small"
                    placeholder="preferences"
                    labelId="Prefenences"
                    id="prefernces"
                    value={task?.taskDate || null}
                    onChange={(value) => {
                        setTask({ ...task, taskDate: value.target.value })
                    }}
                    label="preferences"
                >
                    <MenuItem key={"one"} value={1}>
                        One Day
                    </MenuItem>
                    <MenuItem key={"week"} value={7}>
                        One Week
                    </MenuItem>
                    <MenuItem key={"15"} value={15}>
                        15 Days
                    </MenuItem>
                </Select>
            </FormControl>
        </Box>
        <Typography variant="h6" mt={3}>
            Calender Tasks
        </Typography>
        <FormControl>
            <RadioGroup
                value={task?.calender || "dueDate"}
                onChange={(value) => {
                    setTask({ ...task, calender: value.target.value })
                }}
                row
            >
                <FormControlLabel value="dueDate" control={<Radio />} label="Statutory Due Date" />
                <FormControlLabel value="completedDate" control={<Radio />} label="Expected Completion Date" />
            </RadioGroup>
        </FormControl>

        <BottomBar
            data={task}
            state={initialTask}
            isLoading={isLoading}
            onUpdate={handleUpdateTaskPrefernces}
            onCancel={() => setTask(initialTask)}
        />
    </Box>
}

export default TaskPreferences